<template>
    <div id="print" class="course_main" :style="{'background-color': '#275ba9'}">
        <div class="back_nav" @click="goBack"><img src="../../assets/back_nav.png"/></div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="@/assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="@/Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>Quiz</span>
                            <img src="@/assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <audio class="audio" :src="greatAudio" id="great_audio" @ended="playMp3Ended('great_audio')" @error="playMp3Ended('great_audio')"/>

        <div class="word_main">
            <div class="page_num">
                <div class="num_title"><span>{{objPage.pageNumber}}</span></div>
                <div class="lesson_audio">
                    <div class="info">
                        <div class="title">本页音频</div>
                        <div class="mp3_progress">
                            <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                        </div>
                        <div class="time">
                            <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                            <div class="time_end">{{objPage.pageAudioDurationDisplayString}}</div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="play" @click="changeStart">
                        <audio v-show="false" v-bind:src="audioUrl" id="musicMp3" @ended="playAudioEnded"></audio>
                        <img v-if="!isPlay" src="@/assets/player_play.png" height="40" width="40"/>
                        <img v-else src="@/assets/player_pause.png" height="40" width="40"/>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="page_word_list">
                <div class="page_word_noscroll">
                    <div class="word_title" v-if="listWord != null && listWord.length > 0">
                        <span>本页词汇</span>
                    </div>

                    <div class="word_card_list" :class="{'word_card_list':true, 'word_card_listPadding':isGreaterThan4(), 'word_card_listcenter':!isGreaterThan4(), 'page_word':isGreaterThan4()}" v-if="listWord != null && listWord.length > 0">
                        <div class="word_card_item" v-for="(wordCard, index) in listWord" :key="index" @click="wordClick(wordCard.pk, wordCard.type)">
                            <div>
                                <div class="english_word"><span><img v-if="wordCard.type === 1" src="@/Images/star.png" />{{wordCard.word}}</span></div>
                                <div class="chinese_word">
                                    {{wordCard.chineseInterpretation}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no_word" v-else>
                        <span>本页无词汇～</span>
                    </div>
                </div>
            </div>
        </div>

        <div id="previous_page" :style="{marginLeft: getStateWidth() + 'px'}" class="previous_page" @click="previousClick" v-show="false"><img src="@/assets/question_left.png" /></div>
        <div id="next_page" class="next_page" @click="nextClick" v-show="false"><img src="@/assets/question_right.png" /></div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                courseId: 0,
                lessonId: 0,
                listPage: [],
                listWord: [],
                objPage: {},
                audioUrl: '',
                currentIndex: 0,
                pageNumber: '',
                isPlaying: false,
                wordChanging: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                showTransition:false,
                progress: 0,
                isPlay: false,
                currentTime: 0,
                mTimer: null
            }
        },
        mounted: function () {
            this.callChangeProgress();
        },
        methods: {
            goBack() {
                this.removePageWordLocalStorage();
                this.$router.go(-1);
            },
            isGreaterThan4() {
                return this.listWord != null && this.listWord.length >= 4;
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    musicMp3.pause()
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3')

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration
                    let perNumber = (numbers * 100).toFixed(2)
                    if (perNumber >= 100) {
                        that.isPlay = false
                        that.progress = 0
                        that.currentTime = 0
                        clearInterval(that.mTimer)
                        that.mTimer = null;
                    } else {
                        that.progress = perNumber
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            finishPlay() {
                let that = this;

                that.isPlay = false
                that.progress = 0
                that.currentTime = 0
                clearInterval(that.mTimer)
                that.mTimer = null;
            },
            callChangeProgress: function () {
                let that = this;
                document.getElementById('musicMp3').pause()
                that.changeProgress()
            },
            getStateWidth: function () {
                return this.getCount(this.$store.state.statusheight) > 22 ? 10 : 0;
            },
            gameQuitClick() {
                this.showTransition = false;
                this.removePageWordLocalStorage();
                this.$router.go(-1);
            },
            nextPageClick: function () {
                this.showTransition = false;
                this.removePageWordLocalStorage();
                this.removeChoicequestionLocalStorage();
                this.$router.replace({name: 'BFChoicequestion', query: {lessonId: this.lessonId, courseId: this.courseId}});
            },
            playMp3Ended(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            previousClick: function () {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                $("#previous_page").hide();
                that.playEnded();

                if (that.currentIndex > 0) {
                    setTimeout(function () {
                        that.currentIndex -= 1;
                        that.objPage = that.listPage[that.currentIndex];
                        that.listWord = that.objPage.wordList;

                        if (!that.isEmpty(that.objPage.pageAudio)) {
                            that.audioUrl = that.$qiNiuDomainBase + that.objPage.pageAudio;
                        } else {
                            that.audioUrl = "";
                        }

                        that.showPreviousNext();
                        that.wordChanging = false;

                        setTimeout(function () {
                            that.playAudio();
                        }, 200);
                    }, 300);
                }
            },
            nextClick: function () {
                let that = this;

                if (that.wordChanging) {
                    return;
                }

                that.wordChanging = true;
                $("#next_page").hide();
                that.playEnded();

                if (that.currentIndex < that.listPage.length - 1) {
                    that.currentIndex += 1;
                    that.objPage = that.listPage[that.currentIndex];
                    that.listWord = that.objPage.wordList;

                    if (!that.isEmpty(that.objPage.pageAudio)) {
                        that.audioUrl = that.$qiNiuDomainBase + that.objPage.pageAudio;
                    } else {
                        that.audioUrl = "";
                    }

                    that.showPreviousNext();
                    that.wordChanging = false;

                    setTimeout(function () {
                        that.playAudio();
                    }, 200);
                }
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            playAudio: function () {
                let that = this;

                if (that.isEmpty(that.audioUrl)) {
                    return;
                }
                that.changeStart();
            },
            playAudioEnded() {
                let that = this;
                that.playEnded();

                if (that.isEmpty(that.pageNumber) && that.currentIndex >= that.listPage.length - 1) {
                    that.showTransition = true;
                    const greatAudio = document.getElementById('great_audio');
                    greatAudio.play();

                    Utils.$emit('setBigCat5Finished', that.lessonId, 3);
                }
            },
            playEnded() {
                let that = this;
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                that.finishPlay();
            },
            wordClick: function (pk, type) {
                if (type === 1) {
                    let that = this;
                    that.playEnded();

                    localStorage.setItem('bfpageword_currentIndex', this.currentIndex + "");
                    localStorage.setItem('bfpageword_pageJson', JSON.stringify(this.listPage));

                    this.$router.push({
                        name: 'BFCoreWord', query: {wordId: pk}
                    });
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showPreviousNext() {
                let that = this;

                let previousPage = $("#previous_page");
                let nextPage = $("#next_page");

                if (that.currentIndex <= 0) {
                    previousPage.hide();
                } else {
                    previousPage.show();
                }

                if (that.currentIndex < that.listPage.length - 1) {
                    nextPage.show();
                } else {
                    nextPage.hide();
                }
            },
            initCreate(autoPlay) {
                let that = this;

                if (that.listPage != null && that.listPage.length > 0) {
                    that.objPage = that.listPage[that.currentIndex];
                    that.listWord = that.objPage.wordList;

                    if (!that.isEmpty(that.objPage.pageAudio)) {
                        that.audioUrl = that.$qiNiuDomainBase + that.objPage.pageAudio;
                    }
                }

                that.hideStatusAndStopAudio();

                if (autoPlay) {
                    setTimeout(function () {
                        that.playAudio();
                    }, 200);
                }

                setTimeout(() => {
                    if (!autoPlay) {
                        transformView();
                    }

                    that.showPreviousNext();
                }, 50);
            }
        },
        created() {
            let that = this;

            if (localStorage == null) {
                return;
            }

            let strCurrentIndex = localStorage.getItem('bfpageword_currentIndex');
            let jsonPage = localStorage.getItem('bfpageword_pageJson');

            if (!that.isEmpty(jsonPage) && !that.isEmpty(strCurrentIndex)) {
                let vLessonId = parseInt(this.$route.query.lessonId);
                let vPageNum = this.$route.query.pageNumber;

                that.listPage = JSON.parse(jsonPage);
                that.lessonId = vLessonId;
                that.pageNumber = vPageNum;
                that.currentIndex = that.getCount(strCurrentIndex);

                that.initCreate(false);
            }
        },
        beforeCreate() {
            let that = this;

            if (localStorage != null) {
                let strCurrentIndex = localStorage.getItem('bfpageword_currentIndex');
                let jsonPage = localStorage.getItem('bfpageword_pageJson');

                if (jsonPage !== null && jsonPage.length > 0
                    && strCurrentIndex !== null && strCurrentIndex.length > 0) {
                    return;
                }
            }

            let vLessonId = parseInt(this.$route.query.lessonId);
            let vCourseId = that.getCount(this.$route.query.courseId);
            let vPageNum = this.$route.query.pageNumber;
            let url = "bigCat/getLessonPage/" + vLessonId;

            if (!that.isEmpty(vPageNum)) {
                url = "bigCat6/getLessonPageInReadingComprehension/" + vLessonId + "/" + vPageNum;
            }

            setTimeout(() => {
                transformView();
            }, 50);

            this.$axios.get(url).then((response) => {
                that.listPage = response.data;
                that.lessonId = vLessonId;
                that.courseId = vCourseId;
                that.pageNumber = vPageNum;
                that.initCreate(true);
            }).catch(function (error) {
                window.console.log(error)
            });
        },
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    img { pointer-events: none; }

    .course_main {
        position: relative;
        width: 100vmax;
        height: 100vmin;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }

    .back_nav {
        position: fixed;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .previous_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        left: 0;
    }
    .next_page {
        position: absolute;
        z-index: 1000;
        top: calc(50vmin - 30px);
        right: 0;
    }
    .previous_page img, .next_page img {
        width: 60px;
        height: 60px;
    }

    .course_main .word_main {
        position: absolute;
        width: 460px;
        height: calc(100vmin - 30px);
        left: calc(50vmax - 230px);
        top: 15px;
        background-color: #0000006a;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .word_main .page_num {
    }
    .word_main .page_num .num_title {
        margin-top: 15px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: white;
    }
    .lesson_audio {
        position: relative;
        background-color: white;
        margin: 15px 0 0 0;
        padding: 10px 15px 15px 15px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        width: calc(100%*7/10);
        left:50%;
        height: 80px;
        -webkit-transform: translateX(-50%);
    }

    .lesson_audio .info {
        margin-right: 50px;
    }

    .lesson_audio .play {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }

    .lesson_audio .info .title {
        font-size: 15px;
        color: #333333;
    }

    .lesson_audio .info .mp3_progress {
        width: 100%;
        height: 4px;
        background-color: #f4f4f4;
        margin-top: 7px;
        margin-bottom: 3px;
    }

    .lesson_audio .info .now_progress {
        position: relative;
    @extend % transition;
        height: 4px;
        background-color: #64c846;
    }

    .lesson_audio .time {
        font-size: 13px;
        color: #666666;
    }

    .lesson_audio .time .time_start {
        float: left;
    }

    .lesson_audio .time .time_end {
        float: right;
    }

    audio {
        display: none;
    }

    .word_main .page_word_list {
        width: 100%;
    }
    .word_main .page_word {
        width: 100%;
        height: calc(100vmin - 50px - 85px - 70px - 40px);
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .word_main .page_word .no_word, .word_main .page_word_noscroll .no_word {
        margin-top: 50px;
        text-align: center;
        font-size: 15px;
        color: white;
    }
    .word_main .page_word_noscroll {
        width: 100%;
    }
    .word_title {
        margin-top: 20px;
        margin-bottom: 10px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;  /* #FEB800; */
        font-size: 18px;
    }
    .word_card_list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .word_card_listPadding {
        padding-left: 5px;
    }
    .word_card_listcenter {
        justify-content: center;
        align-items: center;
    }
    .word_card_list .word_card_item {
        width: 130px;
        height: 80px;
        background-color: white;
        margin-left: 10px;
        margin-right: 10px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .word_card_item .english_word {
        width: 130px;
        font-size: 17px;
        font-weight: bold;
        text-align: center;
    }
    .english_word img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
    }
    .word_card_item .chinese_word {
        width: 130px;
        font-size: 17px;
        text-align: center;
    }

    .transition {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

</style>
